var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "BjDialog",
    {
      attrs: { visible: _vm.visible, width: "500px" },
      scopedSlots: _vm._u([
        {
          key: "footer",
          fn: function () {
            return [
              _c("el-button", { on: { click: _vm.hide } }, [
                _vm._v(_vm._s(_vm.$t("cancelText"))),
              ]),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.confirm } },
                [_vm._v(_vm._s(_vm.$t("okText")))]
              ),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _c(
        "el-form",
        { ref: "form", attrs: { model: _vm.form, "label-width": "80px" } },
        [
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.$t("InternalOrder.form.AbnormalCause"),
                prop: "failReason",
              },
            },
            [
              _c("BjInput", {
                attrs: {
                  type: "textarea",
                  maxlength: _vm.MAX_LENGTH.REMARK,
                  "show-word-limit": "",
                  resize: "none",
                  size: "medium",
                },
                model: {
                  value: _vm.form.failReason,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "failReason", $$v)
                  },
                  expression: "form.failReason",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }